import { Config } from "@/config";
const { TokensContractsMainnet } = require("./tokens-contracts-mainnet");
const { TokensContractsSepolia } = require("./tokens-contracts-sepolia");

export const TokensContracts =
  Config.network.name === "mainnet"
    ? TokensContractsMainnet
    : TokensContractsSepolia;
